import { render, staticRenderFns } from "./PhotoQuestion.vue?vue&type=template&id=ae8eb240&"
import script from "./PhotoQuestion.vue?vue&type=script&lang=js&"
export * from "./PhotoQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports